<template lang="pug">
div(:class="{[$style.accordion]: true, [$style.stateActive]: active}" @click="setActive")
  div(
    :class="$style.accordionTitle")
      .av-heading(v-html="heading")
      Icon(
        :size="32"
        :class="$style.icon"
        name="i:chevron-right-1")
  Transition(name="ease-snappy")
    div(
      :class="$style.panelCollapse"
      v-show="active")
      Block(
        v-for="(innerBlock, key) in block.innerBlocks"
        :key="`accordion-${key}`"
        :block="innerBlock")

</template>

<script>
import { getBlockAttribute } from "~/utils/block"

export default {
  name: "AvAccordion",

  props: {
    block: {
      type: Object, // Record<string, any>
      required: true
    },
    lazy: {
      type: Boolean,
      default: true
    },
    active: {
      type: Boolean,
      default: false
    },
    index: {
      type: Number,
      default: null
    }
  },
  computed: {
    heading() {
      if (!this.block) {
        return ""
      }
      return getBlockAttribute(this.block.attributes, "question")
    }
  },
  methods: {
    setActive() {
      this.$emit("clicked", this.index)
    }
  }
}
</script>

<style lang="css" module>
.accordion {
  @apply relative;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);

  &:before {
    @apply absolute content-[''] top-ds-md left-0 bg-primary;
    width: 4px;
    height: calc(100% - 32px);
  }

  &:first-child {
    border-top: 1px solid rgba(0, 0, 0, 0.1);
  }

  &.stateActive {
    .accordionTitle .icon {
      transform: rotate(-90deg);
    }

    .panelCollapse {
      @apply py-ds-md;
    }
  }

  .accordionTitle {
    @apply w-full p-ds-md pl-ds-ml font-bold cursor-pointer inline-flex justify-between gap-ds-lg items-center;

    .icon {
      @apply relative my-ds-sm;
      color: rgba(0, 0, 0, 0.5);
      transform: rotate(90deg);
      -webkit-transition: all cubic-bezier(0.4, 0, 0.2, 1) 0.25s;
      transition: all cubic-bezier(0.4, 0, 0.2, 1) 0.25s;
    }
  }

  .panelCollapse {
    @apply pl-ds-ml pr-ds-md;
  }
}

section {
  .accordion {
    :global {
      .av-heading {
        @apply text-base mb-0;
      }

      .av-paragraph {
        @apply text-base mb-ds-sm;
      }
    }
  }
}

@screen md {
  .accordion {
    .accordionTitle {
      @apply gap-ds-xxl;
    }
  }

  section {
    .accordion {
      :global {
        .av-heading {
          @apply text-rebrandMd;
        }

        .av-paragraph {
          @apply text-rebrandSm;
        }
      }
    }
  }
}

.highlight {
  @apply text-blue-primary;
}

.panelCollapse {
  p {
    @apply text-base mb-ds-sm;
  }
  div {
    ul {
      @apply list-disc text-base pl-ds-ml mb-ds-md;

      li {
        @apply text-base;
      }
    }
    ol {
      @apply text-base pl-ds-ml mb-ds-md;

      li {
        @apply text-base;
      }
    }
  }
}
</style>
